import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    Button,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableCaption,
    Image,
} from "@chakra-ui/react"

export default function EmployeeListModal({ isOpen, onClose, list, title }) {
    return (
        <Modal isOpen={isOpen} onClose={onClose} size='3xl'>
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>{title}</ModalHeader>
                <ModalCloseButton />

                <ModalBody>
                    <Table variant="striped" borderWidth="1px" borderRadius='lg'>
                        <TableCaption>Detailed View of all {title}</TableCaption>
                        <Thead>
                            <Tr>
                                <Th textAlign='center'>Profile Image</Th>
                                <Th textAlign='center'>Name</Th>
                                <Th textAlign='center'>Company Name</Th>
                                <Th textAlign='center'>Designation</Th>
                                {title.includes('Quiz') && <Th textAlign='center'>Score</Th>}
                            </Tr>
                        </Thead>
                        <Tbody>
                            {
                                list.length > 0 && list.map((employee, idx) =>
                                    <Tr key={idx}>
                                        <Td textAlign='center'><Image src={employee.avatar} alt={employee.first_name} width='60px' height='60px' borderRadius='50%' /></Td>
                                        <Td textAlign='center'>{employee.first_name} {employee.last_name}</Td>
                                        <Td textAlign='center'>{employee.company_name}</Td>
                                        <Td textAlign='center'>{employee.designation}</Td>
                                        {title.includes('Quiz') && <Td textAlign='center'> {Number(employee.scores) !== Math.round(Number(employee.scores)) ? employee.scores.toFixed(2) : employee.scores}</Td>}
                                    </Tr>
                                )
                            }
                        </Tbody>
                    </Table>
                </ModalBody>

                <ModalFooter>
                    <Button colorScheme="blue" mr={3} onClick={onClose}>
                        Close
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}